import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch('/contact.php', {
        method: 'POST',
        body: formDataToSend
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section bg-light">
      <div className="container">
        <h2 className="section-title">Contact Us</h2>
        <h3 className='american-blue' align="center">Ready to optimize your supply chain? Contact us today to discuss how Oxycom can support your business.</h3>
        <div className="grid grid-2">
          <div className="contact-info">
            <div className="contact-details">
              <p><strong>General Enquiries & Sales:</strong></p>
              <div style={{height: '1rem'}}></div>            
              <h4 className='american-blue'> Address:</h4>
              <h4 className='american-blue'>Oxycom Group Headquarters</h4>
              <h4 className='american-blue'>Gentilly Estate</h4>
              <h4 className='american-blue'>Moka</h4>
              <h4 className='american-blue'>Mauritius</h4>
              <div style={{height: '1rem'}}></div>
              <h4 className='american-blue'>
                <a href="mailto:talk2us@oxycomgroup.com" className="contact-link">
                  talk2us@oxycomgroup.com
                </a>                
              </h4>
              <h4 className='american-blue'><a href='tel:+263786566586' className='contact-link'> +263 78 656 6586 </a></h4>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              ></textarea>
            </div>
            
            {submitStatus === 'success' && (
              <div className="alert alert-success">
                Thank you! Your message has been sent successfully. A copy has been sent to your email.
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="alert alert-error">
                Sorry, there was an error sending your message. Please try again or email us directly.
              </div>
            )}
            
            <button 
              type="submit" 
              className="btn" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;